export default __webpack_public_path__ + "static/media/round-boxim4.afb4b662.png";